import { cornbar } from 'cornbar';

export async function shareContent({
    title,
    text,
    url,
    file,
    filename = `${Date.now()}.png`,
    onError
}: {
    title?: string;
    text?: string;
    url?: string;
    file?: Blob;
    filename?: string;
    onError?: (error: unknown) => void;
}) {
    let fileToShare: File | undefined;

    if (file) {
        fileToShare = new File([file], filename, { type: file.type || 'image/png' });
    }

    const shareData: ShareData = {
        title,
        text,
        url,
        ...(fileToShare && { files: [fileToShare] })
    };

    const canShareFiles = fileToShare && typeof navigator.canShare === 'function' && navigator.canShare({ files: [fileToShare] });

    const canShareAll = typeof navigator.share === 'function' && ((!file && (text || url)) || (file && canShareFiles));

    if (canShareAll) {
        try {
            await navigator.share(shareData);
            return;
        } catch (error) {
            onError?.(error);
            return;
        }
    }

    if (!file && url && navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(url);
            cornbar.show({
                title: 'عملیات موفق بود',
                description: 'لینک صفحه کپی شد',
                variant: 'success'
            });
        } catch (err) {
            onError?.(err);
        }
        return;
    }

    if (file) {
        try {
            const blobUrl = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            onError?.(error);
        }
        return;
    }

    onError?.('اشتراک گذاری موفقیت‌آمیز نبود');
}
